import { createAction } from '@reduxjs/toolkit'
import { AppState } from '../../appState'

export const setCreditLimitAvailable = createAction<boolean>(
  'client/setCreditLimitAvailable',
)

export const setCreditLimitAvailableReducer = (
  state: AppState['client'],
  action: ReturnType<typeof setCreditLimitAvailable>,
): void => {
  state.creditLimitAvailable = action.payload
}
